<template>
  <main>
    <div class="bg-white p-3">
      <phone-setting :client="client"></phone-setting>
      <hr class="mt-1 mb-3">
      <recording :client="client"></recording>
      <hr class="mt-0 mb-3">
      <m-o-h :client="client"></m-o-h>
      <hr class="mt-2 mb-3">
      <i-v-r :client="client"></i-v-r>
      <hr class="mt-2 mb-3">
      <queue :client="client"></queue>
      <hr class="mt-2 mb-3">
      <time-conditions :client="client"></time-conditions>
      <hr class="mt-2 mb-3">
      <announcement :client="client"></announcement>
      <hr class="mt-2 mb-3">
      <a-p-i-route :client="client"></a-p-i-route>
      <hr class="mt-2 mb-3">
      <sip-extension :client="client"></sip-extension>
    </div>
  </main>
</template>

<script>
import PhoneSetting from './PhoneSetting.vue';
import Recording from './Recording.vue';
import MOH from './MOH.vue';
import IVR from './IVR.vue';
import TimeConditions from './TimeConditions.vue'
import Announcement from './Announcement.vue';
import Queue from './Queue.vue';
import APIRoute from './APIRoute.vue';
import SipExtension from './SipExtension.vue';

export default {
  props: ['client'],
  components: {PhoneSetting, Recording, MOH, IVR, TimeConditions, Announcement, Queue, APIRoute, SipExtension}
}
</script>